import { PROGRESS_STEP } from '@/features/InvoiceReport/Edit/components/UtilizePastDetails/constants';
import { useDataContext } from '@/features/InvoiceReport/Edit/components/UtilizePastDetails/context/UtilizePastDetailsDataContext';
import { useTranslation } from '@/i18n';
import { RelationDialog } from '@moneyforward/ap-frontend-components';
import { ApPayeeDetail as ApPayeeModel } from 'ap-openapi';
import { FC, memo, useMemo } from 'react';
import { DialogBody } from './Body';
import { Footer } from './Footer';

type Props = {
  selectedPayee?: ApPayeeModel;
};

export const PaymentRequestsDialog: FC<Props> = memo(({ selectedPayee }) => {
  const { t } = useTranslation();
  const { currentStep, isLoading, onCloseDialog, onCancel, selectedFile } =
    useDataContext();

  const open = useMemo(() => {
    return (
      currentStep === PROGRESS_STEP.ON_OPEN_DIALOG ||
      currentStep === PROGRESS_STEP.ON_SELECT_INVOICE
    );
  }, [currentStep]);

  return (
    <RelationDialog
      open={open}
      onClose={onCloseDialog}
      title={t('payment_past_details_dialog_title')}
      footer={
        <Footer
          onCancel={onCancel}
          disabled={!selectedFile}
          isLoading={isLoading}
        />
      }
    >
      <DialogBody selectedPayee={selectedPayee} />
    </RelationDialog>
  );
});
PaymentRequestsDialog.displayName = 'PaymentRequestsDialog';
